import React from "react";
import Typography from "@material-ui/core/Typography";
const Asset = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Asset
      </Typography>
      <Typography paragraph variant="h5">
        Digitize the company assets and check the depreciation
      </Typography>
      <Typography paragraph variant="body1">
        Asset is one of the features under the Finance module to manage the
        company assets and their depreciation. It contains any information
        regarding the asset value, asset quantity, asset disposal, and asset
        depreciation.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Asset list. It is
        displayed like a table that contains download functions, sort, filter,
        and global search on the header area, and contains data navigation and
        refresh function on the footer area. The data column that appears in
        this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Asset ID</b>
        <br />
        Indicates the ID of the Asset.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Asset Code</b>
        <br />
        Indicates the code of the Asset.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Asset Name</b>
        <br />
        Indicates the full name of the Asset.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Disposal Status</b>
        <br />
        Indicates the disposal status of the Asset. There are 3 statuses: Fully
        Disposed, Partially Disposed, and Undisposed.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Depreciation Status</b>
        <br />
        Indicates the depreciation status of the Asset. There are 3 statuses:
        Fully Depreciated, Partially Depreciated, and Undepreciated.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Quantity</b>
        <br />
        Indicates the quantity of the Asset.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Total Asset Value</b>
        <br />
        Indicates the total value of the Asset.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 3 buttons that appear on each row of Asset data with
        specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Asset</b>
        <br />
        This button only appears if the Disposal status is not 'Fully Disposed'.
        It is used to edit the Asset data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Asset Detail</b>
        <br />
        This button is used to navigate to the Asset detail which contains some
        tabs with details below:
        <ul>
          <li>
            <b>Basic Info</b> : This tab is to display the Asset data.
          </li>
          <li>
            <b>Asset Depreciations</b> : This tab is to display any Asset
            Depreciations related to the Asset.
          </li>
          <li>
            <b>Asset Disposals</b> : This tab is to display any Asset Disposals
            related to the Asset.
          </li>
        </ul>
        When opening the Asset detail, there will be 2 buttons appearing on the
        top section. The first button is 'Dispose Asset', which is used to
        dispose the Asset data. The second button is 'Edit Asset' which is used
        to edit the Asset data. Both 2 buttons only appear when the Disposal
        status is not 'Fully Disposed'.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Dispose Asset</b>
        <br />
        This button only appears if the Disposal status is not 'Fully Disposed'.
        It is used to dispose of the Asset data. The Asset data is undeletable
        even though it was disposed of until the quantity is zero for audit and
        history purposes.
      </Typography>
    </React.Fragment>
  );
};

export default Asset;
